import { render } from "./DatasetManagement.vue?vue&type=template&id=b2e6040c&scoped=true"
import script from "./DatasetManagement.vue?vue&type=script&lang=js"
export * from "./DatasetManagement.vue?vue&type=script&lang=js"

import "./DatasetManagement.vue?vue&type=style&index=0&id=b2e6040c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2e6040c"]])

export default __exports__